import * as React from 'react'
import { SubscriptionDetails } from '@modules/subscription/models'
import { SubscriptionSingleModalBase } from '@modules/subscription/options/subscription-single-modal-base'
import { BaseModalProps } from '@components/modals/types'

interface Props extends BaseModalProps {
  subscriptionDetails: SubscriptionDetails
  prices: string[]
}

export const SubscriptionSingleChangeDataModal: React.FC<Props> = ({
  subscriptionDetails,
  toggleIsVisible,
  prices,
}) => (
  <SubscriptionSingleModalBase
    title="Dodaj jednorazową zmianę danych w pakiecie"
    message="Jednorazowa opcja zmiany danych została dodana"
    amounts={prices}
    description="Opcja jednorazowej zmiany danych"
    toggleIsVisible={toggleIsVisible}
    subscriptionDetails={subscriptionDetails}
    url={subscriptionDetails.urls.subscription_single_client_data_change}
  />
)
